import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TokenStorage } from './token.storage';

const AUTH_URLS = [
  environment.auth.login,
  environment.auth.register,
  environment.auth.refresh,
  environment.auth.verifyEmail,
  environment.auth.forgotPassword,
  environment.auth.resetPassword,
  environment.leads.requestDemo,
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isAuthEndpoint = AUTH_URLS.some(url => req.url.startsWith(url));
  const token = TokenStorage.getAccessToken();

  let cloned = req.clone({ withCredentials: true });

  if (token && !isAuthEndpoint) {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
    };

    const tenantGuid = TokenStorage.getTenantGuid();
    if (tenantGuid) {
      headers['X-Tenant-Guid'] = tenantGuid;
    }

    cloned = cloned.clone({ setHeaders: headers });
  }

  return next(cloned);
};
